import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { AmbarAgreementSchemeService } from '../../../services/AmbarAgreementSchemeService';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetAmbarAgreementSchemeListPagingAndFilterRequest, initialGetAmbarAgreementSchemeListPagingAndFilterRequest } from '../../../models/request/ambarAgreementScheme/GetAmbarAgreementSchemeListPagingAndFilterRequest';
import { GetAmbarAgreementSchemeListPagingAndFilterResponse, GetAmbarAgreementSchemeListPagingAndFilterResponseData, GetAmbarAgreementSchemeListPagingAndFilterResponseItem, initialGetAmbarAgreementSchemeListPagingAndFilterResponseData } from '../../../models/response/ambarAgreementScheme/GetAmbarAgreementSchemeListPagingAndFilterResponse';
import AmbarAgreementSchemeListFilters from './Components/AmbarAgreementSchemeListFilters';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { ExportAmbarAgreementSchemeListResponse } from '../../../models/response/ambarAgreementScheme/ExportAmbarAgreementSchemeListResponse';
import { DeleteAmbarAgreementSchemeResponse } from '../../../models/response/ambarAgreementScheme/DeleteAmbarAgreementSchemeResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { ServiceService } from '../../../services/ServiceService';
import { CompanyService } from '../../../services/CompanyService';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const AmbarAgreementSchemeList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Kargo Modülü > Nakliye > Anlaşma Şablonu"
    const pageVersion = "1";
    const [data, setData] = useState<GetAmbarAgreementSchemeListPagingAndFilterResponseData>(initialGetAmbarAgreementSchemeListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetAmbarAgreementSchemeListPagingAndFilterRequest>(initialGetAmbarAgreementSchemeListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Kod', name: 'refNo', order: 0, isVisible: true },
            { title: 'Ad', name: 'name', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'description', order: 0, isVisible: true },
            { title: 'Gelir', name: 'isIncome', order: 0, isVisible: true },
            { title: 'Gider', name: 'isOutcome', order: 0, isVisible: true },
            { title: 'Çarpan', name: 'multiplierName', order: 0, isVisible: true },
            { title: 'Aralık Türü', name: 'intervalTypeName', order: 0, isVisible: true },
            { title: 'Hizmet Kalemi', name: 'serviceName', order: 0, isVisible: true },
            { title: 'Dinamik Hizmet Kalemi', name: 'isDynamicService', order: 0, isVisible: true },
            { title: 'Döviz Cinsi', name: 'currencyTypeName', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'customerName', order: 0, isVisible: true },
            { title: 'Komple', name: 'isComplete', order: 0, isVisible: true },
            { title: 'Baremli', name: 'isScale', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * (filter.take ?? 0)
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteAmbarAgreementScheme = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.ambarAgreementSchemeId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteAmbarAgreementSchemeResponse = await AmbarAgreementSchemeService.deleteAmbarAgreementScheme(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateAmbarAgreementScheme = async (_id: string | undefined = undefined) => {
        navigate('/ambaragreementscheme/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].ambarAgreementSchemeId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetAmbarAgreementSchemeListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetAmbarAgreementSchemeListPagingAndFilterResponse = await AmbarAgreementSchemeService.getAmbarAgreementSchemeListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.ambarAgreementSchemeId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var obj: GetAmbarAgreementSchemeListPagingAndFilterRequest = buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.ambarAgreementSchemeId), columns);

            var response: ExportAmbarAgreementSchemeListResponse = await AmbarAgreementSchemeService.exportAmbarAgreementSchemeList(obj);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }


    // Başlığa tıklayarak sıralanabilen kolonlar.
    const sortableColumns = [
        'refNo', 'name', 'description', 'isIncome', 'isOutcome',
        'multiplierName', 'intervalTypeName', 'serviceName', 'isDynamicService',
        'currencyTypeName', 'customerName', 'isComplete', 'isScale', 'isCustomActive',
        'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (AmbarAgreementSchemeManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        name: { type: 'text' },
        description: { type: 'text' },
        isIncome: YES_NO_FILTER,
        isOutcome: YES_NO_FILTER,
        multiplierName: { type: 'select', loadOptions: () => loadConstants('MULTIPLIER_TYPE') },
        intervalTypeName: { type: 'select', loadOptions: () => loadConstants('INTERVAL_TYPE') },
        serviceName: { type: 'select', loadOptions: () => loadList(ServiceService.getServiceList(undefined), 'serviceId', x => x.name) },
        isDynamicService: YES_NO_FILTER,
        // Listede döviz adı sabitin Value alanından geliyor; seçenek etiketi de o.
        currencyTypeName: { type: 'select', loadOptions: () => loadConstants('CURRENCY') },
        customerName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name) },
        isComplete: YES_NO_FILTER,
        isScale: YES_NO_FILTER,
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetAmbarAgreementSchemeListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "isCustomActive") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "isDynamicService") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item.isDynamicService ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isIncome") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item.isIncome ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isOutcome") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item.isOutcome ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isComplete") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item.isComplete ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "isScale") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item.isScale ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.ambarAgreementSchemeId)} onDoubleClick={!item.companyId ? undefined : () => updateAmbarAgreementScheme(item.ambarAgreementSchemeId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <AmbarAgreementSchemeListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteAmbarAgreementScheme}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updateAmbarAgreementScheme}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2 px-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className="new-table-container">
                            <table>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>

                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                    <input onChange={() => setItemSelected(item.ambarAgreementSchemeId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={(filter.take ?? 0)}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / (filter.take ?? 0))}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default AmbarAgreementSchemeList;